/** @jsx jsx */
import Collapse from 'antd/es/collapse'
import 'antd/es/collapse/style/index.css'
import collapseArrow from 'images/collapse-arrow.svg'
// import paymentChequeImg from 'images/payment-cheque.svg'
import paymentInteracImg from 'images/payment-interac.svg'
import paymentWireImg from 'images/payment-wire.svg'
import React from 'react'
import {jsx} from 'theme-ui'
import RawHTML from './RawHTML'
const {Panel} = Collapse

const PanelHeader = ({title, icon}: {title: string; icon: string}) => {
  return (
    <div
      sx={{
        fontFamily: 'Lato Medium',
        fontSize: [15, , 18],
        color: 'primary',
        display: 'flex',
        alignItems: 'center',
        maxWidth: [232, , 'unset'],
      }}
    >
      <img src={icon} alt="" sx={{mr: 12}} />
      {title}
    </div>
  )
}

type Props = {
  title: string
  interacBankTitle: string
  interacBankNote: React.ReactElement
  interacBankItems: Array<{
    name: string
    email: string
  }>
  bankWireTransferTitle: string
  bankWireTransferItems: Array<{
    label: string
    content: string
  }>
  // chequeTitle: string
  // chequeContent: string
}

const DonationOtherMethods: React.FC<Props> = ({
  title,
  interacBankTitle,
  interacBankNote,
  interacBankItems,
  bankWireTransferTitle,
  bankWireTransferItems,
  // chequeTitle,
  // chequeContent,
}) => {
  return (
    <React.Fragment>
      <div
        sx={{
          width: [, , 1028],
          mx: 'auto',
          maxWidth: [, , '90%'],
        }}
      >
        <div
          sx={{
            mt: [60, , 40],
            mb: [60, , 60],
            width: [, , 588],

            px: [28, , 0],
          }}
        >
          <h2
            sx={{
              mt: 0,
              mb: [0, , 6],
              fontSize: [18, , 24],
              color: '#333',
            }}
          >
            {title}
          </h2>
          <Collapse
            expandIconPosition="right"
            expandIcon={({isActive}) => (
              <div>
                <img
                  src={collapseArrow}
                  sx={{
                    transform: `rotate(${isActive ? 0 : -180}deg)`,
                    transition: `transform 0.2s linear`,
                  }}
                />
              </div>
            )}
            sx={{
              mt: 30,
              '&.ant-collapse': {
                backgroundColor: 'transparent',
                border: 'none',
              },
              '.ant-collapse-header': {
                p: '6px !important',
              },
              '.ant-collapse-content': {
                borderTop: 'none',
                borderRadius: 8,
              },
              '.ant-collapse-item': {
                backgroundColor: '#fff',
                marginTop: 24,
                boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.02)',
                borderRadius: '8px !important',
              },
            }}
          >
            <Panel
              key={0}
              header={
                <PanelHeader
                  icon={paymentInteracImg}
                  title={interacBankTitle}
                />
              }
            >
              <div
                sx={{
                  pt: [15, , 32],
                  pb: [15, , 44],
                  px: [15, , 68],
                }}
              >
                <h4
                  sx={{
                    my: 0,
                    fontSize: 12,
                    fontWeight: 400,
                    color: '#666',
                    pt: 0,
                    pb: 16,
                  }}
                >
                  {interacBankNote}
                </h4>
                {interacBankItems.map(({name, email}) => {
                  return (
                    <div
                      key={name}
                      sx={{
                        borderTop: '1px solid #F5F5F5',
                        py: 12,
                        display: 'flex',
                        flexDirection: ['column', , 'row'],
                      }}
                    >
                      <span
                        sx={{
                          flex: 1,
                          fontFamily: 'Lato Medium',
                          fontSize: 15,
                          color: '#333',
                        }}
                      >
                        {name}
                      </span>
                      <span
                        sx={{
                          flex: 1,
                          fontSize: 16,
                          color: '#666',
                          mt: [15, 0, 0],
                          display: 'block',
                        }}
                      >
                        {email}
                      </span>
                    </div>
                  )
                })}
              </div>
            </Panel>
            <Panel
              key={1}
              header={
                <PanelHeader
                  icon={paymentWireImg}
                  title={bankWireTransferTitle}
                />
              }
            >
              <div sx={{pt: [15, , 32], pb: [15, , 44], px: [15, , 68]}}>
                {bankWireTransferItems.map(({label, content}) => {
                  return (
                    <div
                      key={label}
                      sx={{
                        borderTop: '1px solid #F5F5F5',
                        py: 8,
                        flexDirection: ['column', , 'row'],
                        display: 'flex',
                      }}
                    >
                      <span
                        sx={{
                          flex: 1,
                          fontFamily: 'Lato Medium',
                          fontSize: 16,
                          color: '#333',
                        }}
                      >
                        {label}
                      </span>
                      <span sx={{flex: 1, fontSize: 16, color: '#666'}}>
                        {content}
                      </span>
                    </div>
                  )
                })}
              </div>
            </Panel>
            {/* <Panel
              key={2}
              header={
                <PanelHeader icon={paymentChequeImg} title={chequeTitle} />
              }
            >
              <RawHTML
                sx={{
                  pt: [15, , 32],
                  pb: [15, , 44],
                  px: [15, , 68],
                  fontSize: 16,
                  color: '#666',
                  h3: {
                    fontSize: 16,
                    color: '#333',
                    fontWeight: 400,
                    my: 0,
                  },
                  p: {
                    mt: 0,
                  },
                }}
              >
                {chequeContent}
              </RawHTML>
            </Panel> */}
          </Collapse>
        </div>
      </div>
      <div
        sx={{
          width: [, , 1028],
          mx: 'auto',
          maxWidth: [, , '90%'],
        }}
      ></div>
    </React.Fragment>
  )
}

export default DonationOtherMethods
